import type { StyleRule } from '@archipro-design/aria';

export const PageBase: StyleRule = () => ({
    minHeight: '100vh',

    '@supports(height: 100dvh)': {
        minHeight: '100dvh',
    },
});

export const PageContent: StyleRule = ({ theme, currentPageTheme }) => ({
    flex: '1',
    touchAction: 'auto',
    ...(currentPageTheme === 'default' && {
        // Falls back to the classic 74px nav clearance; MobileHeader overrides
        // `--mobile-header-height` when a warning strip makes the fixed bar taller.
        paddingTop: 'var(--mobile-header-height, 4.625rem)',
        [theme.screen.tablet]: {
            paddingTop: 0,
        },
    }),
});
